export default __webpack_public_path__ + "static/Roobert-Light-ef5a4faa34e1611d12d9f0d4b446c435.woff";